import { render, staticRenderFns } from "./image_app.vue?vue&type=template&id=1e551b52&"
import script from "./image_app.vue?vue&type=script&lang=ts&"
export * from "./image_app.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports